module.exports = __webpack_public_path__ + "static/media/check-orange.c9986aac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-page/check-orange.svg
// module id = 33
// module chunks = 0